import { useState } from "react";
import Submit from "./Submit";
import ValidSession from "./ValidSession";

const ResetPassword = ({ onBackToLogin, code, logout, message}) => {
    const sessionId = typeof code === 'object' ? code?.session : code;
    const resetToken = typeof code === 'object' ? code?.token : null;
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [active, setActive] = useState(false);
    const [loading, setLoading] = useState(true);
    const [redirecting, setRedirecting] = useState(false);

    const canSubmit = () => !!sessionId && !!resetToken && password && password === confirm && active && !loading;

    ValidSession({
        code: sessionId,
        resetToken,
        redirecting,
        logout,
        message,
        setLoading,
        setActive
    })
    
    const submit = Submit({
        code: sessionId,
        resetToken,
        password,
        active,
        confirm,
        message,
        logout,
        onBackToLogin,
        setLoading,
        setRedirecting
    })

    const returnPage = () => {
        onBackToLogin();
    }

    return {
        loading,
        active,
        password,
        confirm,
        redirecting,
        submit,
        setPassword,
        setConfirm,
        canSubmit,
        returnPage
    }  
};

export default ResetPassword;
